import type { CSSProperties } from 'react';
import cx from 'classnames';

import { initials } from 'src/shared/utils/contact';

interface AvatarProps {
  name: string;
  /** Diameter in pixels. */
  size?: number;
  variant?: 'nude' | 'ink';
  className?: string;
}

/** Initials on a disc. Decorative: the name is always written next to it. */
export default function Avatar({ name, size = 40, variant = 'nude', className }: AvatarProps) {
  return (
    <span
      className={cx('v-avatar', { 'v-avatar--ink': variant === 'ink' }, className)}
      style={{ '--v-avatar-size': `${size}px` } as CSSProperties}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  );
}
